import { css } from 'goober';

/**
 * Panel root/base styles
 */
export const rootBase = css`
  font-size: 13px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  border-radius: var(--panel-radius);
  box-shadow: var(--panel-shadow-md);
  border: 1px solid rgba(0, 0, 0, 0.08);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transition:
    box-shadow 0.2s ease,
    opacity 0.2s ease;

  &:hover:not([data-dragging='true']) {
    box-shadow: var(--panel-shadow-lg);
  }
`;

/**
 * Panel body style with standard padding
 */
export const panelBody = css`
  padding: 12px;
`;

/**
 * Panel-specific positioning styles
 */
export const isoRoot = css`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 240px;
`;

export const boundaryRoot = css`
  position: absolute;
  top: 90px; /* Below zoom controls */
  left: 10px;
  width: 200px;
`;

export const legendRoot = css`
  position: absolute;
  bottom: 25px;
  right: 10px;
  width: 200px;
  max-height: 300px;
  overflow-y: auto;
`;

/**
 * Get panel-specific root class based on panel ID
 */
export function getPanelRootClass(id?: string): string {
  const classes = [rootBase];

  if (id === 'iso-control') classes.push(isoRoot);
  else if (id === 'boundary-control') classes.push(boundaryRoot);
  else if (id === 'type-legend') classes.push(legendRoot);

  return classes.filter(Boolean).join(' ');
}
